import { render, staticRenderFns } from "./marKetingCoupon.vue?vue&type=template&id=2ff8ecb4&scoped=true&"
import script from "./marKetingCoupon.vue?vue&type=script&lang=js&"
export * from "./marKetingCoupon.vue?vue&type=script&lang=js&"
import style0 from "./marKetingCoupon.vue?vue&type=style&index=0&id=2ff8ecb4&scoped=true&lang=css&"
import style1 from "./marKetingCoupon.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8ecb4",
  null
  
)

export default component.exports